import {exhibitionScenarioConstants} from "../constants/exhibition-scenario.constants";

const initState = {
    exhibitionScenarioList: null,
    exhibitionScenarioItem: null,
    exhibitionScenarioDropdown: null,
    validationError: null
};

export function exhibitionScenarioReducer(state = initState, action) {
    switch (action.type) {
        case exhibitionScenarioConstants.EXHIBITION_SCENARIO_LIST_REQUEST:
        case exhibitionScenarioConstants.EXHIBITION_SCENARIO_LIST_FAILURE:
            return {
                ...state,
                exhibitionScenarioList: null,
            }
        case exhibitionScenarioConstants.EXHIBITION_SCENARIO_LIST_SUCCESS:
            return  {
                ...state,
                exhibitionScenarioList: action.scenario
            }

        case exhibitionScenarioConstants.EXHIBITION_SCENARIO_GET_BY_ID_REQUEST:
        case exhibitionScenarioConstants.EXHIBITION_SCENARIO_GET_BY_ID_FAILURE:
            return {
                ...state,
                exhibitionScenarioItem: null,
            }
        case exhibitionScenarioConstants.EXHIBITION_SCENARIO_GET_BY_ID_SUCCESS:
            return  {
                ...state,
                exhibitionScenarioList: action.scenario
            }
        case exhibitionScenarioConstants.EXHIBITION_SCENARIO_DROPDOWN_LIST_REQUEST:
        case exhibitionScenarioConstants.EXHIBITION_SCENARIO_DROPDOWN_LIST_FAILURE:
            return {
                ...state,
                exhibitionScenarioDropdown: null,
            }
        case exhibitionScenarioConstants.EXHIBITION_SCENARIO_DROPDOWN_LIST_SUCCESS:
            return {
                ...state,
                exhibitionScenarioDropdown: action.scenario
            };
        default:
            return state
    }
}